export const barangaySelector = (state) => state.barangay;